

<script>


	import { determinarCuentaSuspendida } from './controllers.js'

	export let docDataCuenta = {}

	const suspendingInfo = determinarCuentaSuspendida(docDataCuenta)

	let showModal = true

</script>


<div class="message {suspendingInfo.status}" >
	{suspendingInfo.message}
	<a style="color: inherit; text-decoration: underline;" target="_blank" href="https://www.metrokubiko.com/planes">Actualizar Cuenta</a>
</div>


{#if suspendingInfo.status === 'suspended' && showModal}

	<div class="cuenta_suspendida-modal" >
		<div class="cuenta_suspendida-modal__display">

			<div class="cuenta_suspendida-modal__display__header">
				<span></span>
				<span class="cuenta_suspendida-modal__display__header__btn-close" title="Cerrar" on:click={() => showModal = false}>
					<i class="fas fa-times"></i>
				</span>
			</div>

			<div class="cuenta_suspendida-modal__display__body">

				<div class="cuenta_suspendida-modal__display__body__message" style="flex: auto;">
					<p>
						Su cuenta se venció el dia <span class="message-date"></span> por falta de pago.
					</p>

					<p>
						Los cambios que realize no se guardarán en la base de datos.
					</p>

					<p>
						Todos los proyectos que se han creado pueden ser consultados durante seis meses a partir de los cuales se eliminará la información.
					</p>

					<p>
						Para mayor información comuniquese al WhatsApp +57 316 745 0572.
					</p>
				</div>

				<div class="cuenta_suspendida-modal__display__body__message" style="text-align: center;">
					<a class="" href="https://www.metrokubiko.com/planes" target="_blank">
						Actualizar Cuenta
					</a>
				</div>
			</div>

		</div>
	</div>

{/if}


<style>

	.message{
		text-align: center;
		display: none;
		color: white;
		width: 100%;
		padding: 15px;
		margin: 0px 50px;
		font-size: 1.1rem;
		border-radius: 4px;
		box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 50%);
	}

	.message.suspended {
		background: #ff3400;
		display: block;
	}

	.message.for_suspending {
		background: #ffa900;
		display: block;
		color: #333;
	}


	.cuenta_suspendida-modal {
		justify-content: center;
		align-items: flex-end;
		position: fixed;
		display: flex;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		z-index: 100;
		backdrop-filter: blur(2px);
		-webkit-backdrop-filter: blur(2px);
		background-color: rgba(0, 0, 0, .5);
	}

	.cuenta_suspendida-modal__display {
		flex-direction: column;
		position: relative;
		overflow: auto;
		display: flex;
		--margin: 20px;
		width: min(100%, 500px);
		height: min(100%, 500px);
		--color: rgb(35 40 42 / 80%);
		background-color: rgb(238 238 238 / 60%);
	}

	.cuenta_suspendida-modal__display__header {
		justify-content: space-between;
		background: transparent;
		align-items: center;
		display: flex;
		width: 100%;
		height: 50px;
		min-height: 50px;
		font-weight: 600;
		font-size: .9rem;
		padding: 0px 25px;
	}

	.cuenta_suspendida-modal__display__header__btn-close {
		cursor: pointer;
	}

	.cuenta_suspendida-modal__display__body {
		flex-direction: column;
		position: relative;
		display: flex;
		flex: auto;
		font-weight: 400;
	}

	.cuenta_suspendida-modal__display__body__message {
		margin: 10px 30px 20px;
		background: #eeeeee;
		padding: 10px 20px;
		border-radius: 4px;
		font-size: 1rem;
		font-weight: 400;
		color: rgba(0, 0, 0, .75);
	}

</style>